import { createContext } from 'react';
const myContextContext = createContext(null);
export default myContextContext;
